import { IonSkeletonText } from "@ionic/react";

export const NewsDetailsSkeleton = () => {
  return (
    <div className="h-full overflow-y-auto overscroll-none mt-[-4px]">
      <div className="flex-col items-center w-full">
        {/* Skeleton for header image */}
        <div className="relative w-full max-w-[576px] mx-auto">
          <IonSkeletonText
            animated
            style={{
              height: "200px",
              borderRadius: "0px",
              "--background-rgb": "255, 255, 255",
              opacity: "1",
            }}
          />
        </div>

        <div className="p-4 w-full">
          {/* Skeleton for title */}
          <div className="mb-2">
            <IonSkeletonText
              animated
              style={{
                height: "28px",
                width: "90%",
                "--background-rgb": "255, 255, 255",
                opacity: "1",
              }}
            />
          </div>
          <div className="mb-4">
            <IonSkeletonText
              animated
              style={{
                height: "28px",
                width: "70%",
                "--background-rgb": "255, 255, 255",
                opacity: "1",
              }}
            />
          </div>

          {/* Skeleton for article info */}
          <div className="flex justify-between items-center w-full mt-4 border-b border-white/10 pb-4">
            <div className="flex items-center gap-2">
              <IonSkeletonText
                animated
                style={{
                  height: "12px",
                  width: "130px",
                  "--background-rgb": "255, 255, 255",
                  opacity: "1",
                }}
              />
            </div>
          </div>

          {/* Skeleton for article content */}
          <div className="mt-4">
            <article className="prose prose-slate max-w-none w-full">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="mb-4">
                  <IonSkeletonText
                    animated
                    style={{
                      height: "14px",
                      width: "100%",
                      "--background-rgb": "255, 255, 255",
                      opacity: "1",
                    }}
                  />
                  <IonSkeletonText
                    animated
                    style={{
                      height: "14px",
                      width: "95%",
                      "--background-rgb": "255, 255, 255",
                      opacity: "1",
                      marginTop: "8px",
                    }}
                  />
                  <IonSkeletonText
                    animated
                    style={{
                      height: "14px",
                      width: "90%",
                      "--background-rgb": "255, 255, 255",
                      opacity: "1",
                      marginTop: "8px",
                    }}
                  />
                </div>
              ))}
            </article>
          </div>

          {/* Skeleton for like section */}
          <div className="mt-12 flex items-center gap-[42px]">
            <div>
              <IonSkeletonText
                animated
                style={{
                  height: "16px",
                  width: "140px",
                  "--background-rgb": "255, 255, 255",
                  opacity: "1",
                }}
              />
            </div>

            <div className="flex items-center gap-2.5">
              <div className="w-[31.2px] h-[31.2px] rounded-[6px]">
                <IonSkeletonText
                  animated
                  style={{
                    height: "31.2px",
                    width: "31.2px",
                    borderRadius: "6px",
                    "--background-rgb": "255, 255, 255",
                    opacity: "1",
                  }}
                />
              </div>
              <div className="w-[31.2px] h-[31.2px] rounded-[6px]">
                <IonSkeletonText
                  animated
                  style={{
                    height: "31.2px",
                    width: "31.2px",
                    borderRadius: "6px",
                    "--background-rgb": "255, 255, 255",
                    opacity: "1",
                  }}
                />
              </div>
            </div>
          </div>

          {/* Skeleton for suggested questions */}
          <div className="mt-12 w-full">
            <div className="flex items-center gap-2 w-full">
              <div className="w-[28px] h-[28px] rounded-full">
                <IonSkeletonText
                  animated
                  style={{
                    height: "28px",
                    width: "28px",
                    borderRadius: "50%",
                    "--background-rgb": "255, 255, 255",
                    opacity: "1",
                  }}
                />
              </div>
              <IonSkeletonText
                animated
                style={{
                  height: "16px",
                  width: "120px",
                  "--background-rgb": "255, 255, 255",
                  opacity: "1",
                }}
              />
            </div>

            <div className="flex-col mt-2 w-full pb-[80px]">
              {[...Array(3)].map((_, i) => (
                <div
                  key={i}
                  className="flex justify-between gap-3 items-center border-b border-white/10 py-4 pr-1"
                >
                  <IonSkeletonText
                    animated
                    style={{
                      height: "12px",
                      width: "90%",
                      "--background-rgb": "255, 255, 255",
                      opacity: "1",
                    }}
                  />
                  <div className="w-[14px] h-[14px]">
                    <IonSkeletonText
                      animated
                      style={{
                        height: "14px",
                        width: "14px",
                        "--background-rgb": "255, 255, 255",
                        opacity: "1",
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsDetailsSkeleton;
